<template>
  <div class="all_part">
    <div class="logo">
      <img src="../assets/main_menu_Phone/Logo.png" alt="" />
    </div>
    <div class="main_button">
      <div class="JiaGeKuCun">
        <div class="TwoButton">
          <div class="button" @click="Second_jiage">
            <img src="../assets/Second_menuComputer_img/BiaoZhun.png" alt="" />
            <span>标准报价库存查询</span>
          </div>
          <div class="button" @click="Second_feibiao">
            <img src="../assets/Second_menuComputer_img/FeiBiao.png" alt="" />
            <span>非标报价库存查询</span>
          </div>
        </div>
      </div>
    </div>
    <div class="search_button">
      <el-button
        type="primary"
        @click="back_menu"
        style="
          height: 48px;
          width: 244px;
          border-radius: 25px;
           background: #409eff;
          color: #ffffff;
        "
        >返回
      </el-button>
    </div>
    <div></div>
  </div>
</template>

<script>
import { httpUrl } from "../components/publics";

export default {
  name: "Main_menuPhone_JiaGeYuKuCun",
  data() {
    return {
      phoneNum: "",
      Password: "",
      userInfo: {},
      codeStatus: false,
      times: "60",
    };
  },
  methods: {
    back_menu() {
      this.$router.push("/Main_menuPhone");
    },
    Second_jiage() {
      this.$router.push("/CompetitionRegistration_phone");
    },
    Second_feibiao() {
      this.$router.push("/FeiBiaoZhunProductTablePahone");
    },
  },
};
</script>

<style>
</style>
<style scoped>
.all_part {
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-image: url("../assets/Login_img_phone/bg1.png");
}
.main_button {
  flex-direction: column;
  align-items: center;
  justify-content: center;
  display: flex;
  width: 100%;
  height: 85%;
}
.logo {
  background-image: url("../assets/main_menu_Phone/bg@3x.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 100%;
  height: 142pt;
  display: flex;
  align-items: center;
  justify-content: center;
}
.logo img {
  margin-top: 18px;
}
.JiaGeKuCun {
  width: 100%;
  margin-top: 20px;
  align-items: center;
  justify-content: space-around;
  display: flex;
  flex-direction: row;
}
.button {
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 120pt;
  width: 120pt;
  background-color: #409eff;
  border-radius: 6px;
}
.buttons {
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 130pt;
  width: 130pt;
  background-color: none;
  border-radius: 6px;
}

.button img {
  width: 40pt;
  height: 44.5pt;
  display: flex;
}
.button span {
  font-weight: 500;
  color: #ffffff;
  font-size: 14pt;
  margin-top: 12px;
}
.TwoButton {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.search_button {
  margin-bottom: 20px;
}

</style>